




























import Vue from 'vue';
import { getDiscountRecord } from '../api';
import homeStore from '../views/stores/home.js';
import infiniteScroll from 'vue-infinite-scroll';

/**
 * 获取正在进行中的活动
 * 动列表只展示进行中的活动（即活动开始时间 > 当前时间 > 活动结束时间）【未到活动开始时间的活动】和【已过活动结束时间的活动】不在【优惠专区首页的活动列表】中展示
 * @param  {[type]} actList [description]
 * @return {[type]}         [description]
 */

export default Vue.extend({
  name: 'discount',
  data() {
    return {
      loading: false,
      record: [],
      showList: true,
      homeStore,
      busy: false,
      pageNum: 0,
    };
  },
  directives: { infiniteScroll },
  created() {
    this.pageNum = 0;
    document.title = homeStore.HISTORY_TITLE;
    this.getDiscount();
  },
  methods: {
    async getDiscount() {
      this.loading = true;
      this.busy = true;
      const record = await getDiscountRecord({
        page_size: '20',
        page_num: this.pageNum,
        qual_type_list: '1',
      });
      this.record = this.record.concat(record);
      this.showList = this.record.length > 0;
      this.loading = false;
      if (record.length >= 20) {
        this.busy = false;
        this.pageNum++;
      }
    },
    getPic(list) {
      return list.logo;
    },
    getTime(list) {
      return list.create_time.substr(0, 10);
    },
    getDescription(list) {
      return list.act_name;
    },
    getAct(list) {
      return `獲贈${list.prize_name} × ${list.count}` ;
    },
    getUrl(list) {
      if (list.type === '1') {
        let jumpUrl = list.jump_url;
        if (jumpUrl === 'https://prom.wechatpay.com.hk/mojo/prom/app_4_889/index.shtml') {
          jumpUrl = 'https://prom.wechatpay.com.hk/mojo/prom/app_4_889/index.shtml?ADTAG=stamspeaker';
        }
        location.href = jumpUrl;
      } else if (list.type === '2') {
        location.href = `https://hkwallet.moneydata.hk/cgi-bin/app/ewallet_bindcard/ewallet_coupon_index.cgi?page=coupon-detail&discount_center=1&user_coupon_id=${list.prize_key}`;
      }
    },
  },
});
